import { useProductionStore } from "../../../stores/production";

const ProductionByUser = () => {
  const { production2 } = useProductionStore();

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto mt-5 overflow-x-scroll overflow-y-scroll">
      <thead className="sticky top-0">
        <tr className="h-12">
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-44">
            Utilisateurs
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Potentiel Max
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Heure ABS
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Temps passé
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Temps XS
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Temps Client
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Temps Admin
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Heure validées
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            % ABS
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            % Actif
          </th>
        </tr>
      </thead>
      <tbody>
        {production2?.collabs?.map((user: any, index: any) => (
          <tr key={index} className="h-8">
            <td className="border border-gray-300 px-4 py-2 text-left w-44">
              {user.collaborator}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.potentialMax === 0 ? " " : user.potentialMax}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.heureABS === 0 ? " " : user.heureABS}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.tempsPasse === 0 ? " " : user.tempsPasse}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.tempsClientXS === 0 ? " " : user.tempsClientXS}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.tempsClientNoXS === 0 ? " " : user.tempsClientNoXS}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.tempsAdmin === 0 ? " " : user.tempsAdmin}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.heureValidees === 0 ? " " : user.heureValidees}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.pctABS === "0%" ? " " : user.pctABS}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {user.pctActif === "0%" ? " " : user.pctActif}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <td className="border border-gray-300 px-4 py-2 text-left w-44">
            TOTAL
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {production2?.total?.potentialMax === 0
              ? " "
              : production2?.total?.potentialMax}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {production2?.total?.heureABS === 0
              ? " "
              : production2?.total?.heureABS}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {production2?.total?.tempsPasse === 0
              ? " "
              : production2?.total?.tempsPasse}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
          {production2?.total?.tempsClientXS === 0
              ? " "
              : production2?.total?.tempsClientXS}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
          {production2?.total?.tempsClientNoXS === 0
              ? " "
              : production2?.total?.tempsClientNoXS}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {production2?.total?.tempsAdmin === 0
              ? " "
              : production2?.total?.tempsAdmin}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {production2?.total?.heureValidees === 0
              ? " "
              : production2?.total?.heureValidees}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
        </tr>
      </tfoot>
    </table>
  );
};

export default ProductionByUser;
